import { Controller } from "@hotwired/stimulus"

// Slides the oracle right panel up from the bottom on viewports below the
// desktop breakpoint, and dismisses it via the backdrop, close button, or Esc.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.boundEsc = this.handleEsc.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEsc)
    document.body.classList.remove("oracle-panel-locked")
  }

  open(event) {
    event?.preventDefault()
    this.panelTarget.classList.add("oracle-panel--open")
    this.backdropTarget.classList.add("oracle-panel-backdrop--open")
    document.body.classList.add("oracle-panel-locked")
    document.addEventListener("keydown", this.boundEsc)
  }

  close(event) {
    event?.preventDefault()
    this.panelTarget.classList.remove("oracle-panel--open")
    this.backdropTarget.classList.remove("oracle-panel-backdrop--open")
    document.body.classList.remove("oracle-panel-locked")
    document.removeEventListener("keydown", this.boundEsc)
  }

  handleEsc(event) {
    if (event.key === "Escape") this.close()
  }
}
